import { render, staticRenderFns } from "./OnneAppView.vue?vue&type=template&id=2045060c&scoped=true&"
var script = {}
import style0 from "./OnneAppView.vue?vue&type=style&index=0&id=2045060c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2045060c",
  null
  
)

export default component.exports